module.exports = __webpack_public_path__ + "static/media/hero.870ec57d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/alabama-rural-studio/hero.jpg
// module id = 53
// module chunks = 0